import React, {Component, Fragment} from 'react';
import ReadyButton from '../../components/ReadyButton';
import AudioPlayer from '../../components/AudioPlayer';
import strings from '../../strings';

import de_sm_intro from '../../assets/sounds/de/intros/NonWOrdInstruction.mp3';

class IntroNonwords extends Component {
	constructor(props) {
		super(props);
		this.audio = de_sm_intro;
	}
	render() {
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return (
			<Fragment>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.nono_intro1}
				</p>
				<p>{strings.nono_intro2}</p>
				<p>{strings.nono_intro3}</p>
				<ReadyButton
					onReadyChange={this.props.setReady}
					isAdultTest={isAdultFollowup}
				/>
			</Fragment>
		);
	}
}

export default IntroNonwords;
